import React from "react";
import { Container, Table } from "reactstrap";
import styles from "./FinanceOverview.module.scss";

const FinanceOverview = () => {
  const overviewData = [
    { period: "Today", totalSales: "$500", totalEarnings: "$450", pendingPayments: "$450", estimatedFutureSales: "$600" },
    { period: "This Week", totalSales: "$2,500", totalEarnings: "$2,200", pendingPayments: "$2,200", estimatedFutureSales: "$3,000" },
    { period: "This Month", totalSales: "$10,000", totalEarnings: "$8,500", pendingPayments: "$8,500", estimatedFutureSales: "$12,000" },
  ];

  const recentTransactionsData = [
    { type: "Sale", orderId: "Order #45678", productDetails: "Blue colored headphones", amount: "$600", status: "Completed" },
    { type: "Refund", orderId: "Order #45678", productDetails: "Blue colored headphones", amount: "$3,000", status: "Completed" },
  ];

  return (
    <div className={styles.financeOverview}>
      <h4 className="fw-semibold mb-3">Overview</h4>
      <Container fluid className="px-3">
        <Table responsive bordered hover className={styles.table}>
          <thead className={styles.headOrange}>
            <tr>
              <th>Period</th>
              <th>Total Sales</th>
              <th>Total Earnings</th>
              <th>Pending Payments</th>
              <th>Estimated Future Sales</th>
            </tr>
          </thead>
          <tbody>
            {overviewData.map((item, index) => (
              <tr key={index}>
                <td>{item.period}</td>
                <td>{item.totalSales}</td>
                <td>{item.totalEarnings}</td>
                <td>{item.pendingPayments}</td>
                <td>{item.estimatedFutureSales}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Container>

      <h4 className="fw-semibold my-3">Recent Transactions</h4>
      <Container fluid className="px-3">
        <Table responsive hover className={styles.table}>
          <thead className={styles.headGray}>
            <tr>
              <th>Type</th>
              <th>Order ID</th>
              <th>Product Details</th>
              <th>Amount</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {recentTransactionsData.map((item, index) => (
              <tr key={index}>
                <td>{item.type}</td>
                <td>{item.orderId}</td>
                <td>{item.productDetails}</td>
                <td>{item.amount}</td>
                <td>{item.status}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Container>
    </div>
  );
};

export default FinanceOverview;